import { render, staticRenderFns } from "./acr.vue?vue&type=template&id=b889444a&scoped=true&"
import script from "./acr.vue?vue&type=script&lang=js&"
export * from "./acr.vue?vue&type=script&lang=js&"
import style0 from "./acr.vue?vue&type=style&index=0&id=b889444a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b889444a",
  null
  
)

export default component.exports